import {
  ActionIcon,
  Anchor,
  Avatar,
  CloseButton,
  Group,
  Stack,
  Text,
} from "@mantine/core";
import React from "react";
import { tagsColumn } from "../../../../../../layouts/Table/columns/tagsColumn";
import { updateProspect } from "../../../../../../api/PRMAPI";
import {
  useLeadsContainerStore,
  useLeadsSheetStore,
} from "../../../../../../stores/LeadsStore";
import PositiveChanger from "../../actions/PositiveChanger";
import { IconChevronLeft } from "@tabler/icons-react";

const LeadsSheetMobileHeading = ({
  about,
  active,
  setActive,
  handleSheetClose,
}) => {
  const current = useLeadsSheetStore((s) => s.current);
  const setCurrent = useLeadsSheetStore((s) => s.setCurrent);
  const currentContainer = useLeadsSheetStore((s) => s.currentContainer);
  const updateContainerItem = useLeadsContainerStore(
    (s) => s.updateContainerItem
  );

  const onTagEdited = (newTags) => {
    setCurrent({ ...current, tags: newTags });
    updateContainerItem(currentContainer.id, current.id, { tags: newTags });
  };

  if (active === "main") {
    return (
      <Group wrap="nowrap">
        <CloseButton
          pos={"absolute"}
          top={4}
          right={4}
          onClick={handleSheetClose}
          size={"lg"}
        />

        <Avatar
          color="initials"
          src={about.contact_image_url}
          name={about.firstName + " " + about.lastName}
          imageProps={{
            referrerPolicy: "no-referrer",
          }}
          radius={"xl"}
          size={64}
          variant="filled"
        />
        <Stack gap={8} flex={"1 1 auto"}>
          <Group wrap="nowrap">
            <Anchor truncate fw={600} c={"#333"} fz={14}>
              {about.firstName} {about.lastName}
            </Anchor>
          </Group>

          <Text size="xs" truncate="end" maw={250}>
            {about.jobTitle}
          </Text>

          <Text size="xs" truncate="end" maw={250}>
            {about.company}
          </Text>

          <Group wrap="nowrap">
            {tagsColumn({
              editFunction: () => updateProspect,
              wrapperProps: { py: 4 },
              onEdited: onTagEdited,
            }).renderCell({
              row: current,
              value: current?.tags?.map((e) => e.name).join(", "),
            })}

            <PositiveChanger
              containerId={currentContainer?.id}
              is_positive={current?.is_positive}
              itemId={current?.id}
              isInDetail
              pos="static"
              mt={0}
            />
          </Group>
        </Stack>
      </Group>
    );
  }

  return (
    <Group
      wrap="nowrap"
      bg={"var(--mantine-color-primary-1)"}
      m={-16}
      style={{ borderRadius: 8 }}
      p={"md"}
      py={"xs"}
      mb={0}
    >
      <ActionIcon
        onClick={() => setActive("main")}
        size={"xl"}
        variant="subtle"
        ml={-12}
      >
        <IconChevronLeft size={48} />
      </ActionIcon>
      <Avatar
        color="initials"
        src={about.contact_image_url}
        name={about.firstName + " " + about.lastName}
        imageProps={{
          referrerPolicy: "no-referrer",
        }}
        radius={"xl"}
        size={48}
        variant="filled"
      />
      <Stack gap={8} flex={"1 1 auto"}>
        <Group wrap="nowrap">
          <Anchor truncate fw={600} c={"#333"} fz={14} maw={180}>
            {about.firstName} {about.lastName}
          </Anchor>
        </Group>

        <Text size="xs" truncate="end" maw={180}>
          {about.jobTitle}
        </Text>

        <Text size="xs" truncate="end" maw={180}>
          {about.company}
        </Text>
      </Stack>

      <PositiveChanger
        containerId={currentContainer?.id}
        is_positive={current?.is_positive}
        itemId={current?.id}
        isInDetail
        pos="static"
        mt={0}
      />
    </Group>
  );
};

export default LeadsSheetMobileHeading;
